export default __webpack_public_path__ + "static/media/Bengal Tiger.a393d383.jpg";